module.exports = __webpack_public_path__ + "img/Estate-duty.07709abd.svg";